import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "admin-members" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "header-stats" }
const _hoisted_4 = { class: "search-container" }
const _hoisted_5 = { class: "member-info" }
const _hoisted_6 = { class: "avatar-text" }
const _hoisted_7 = { class: "member-name" }
const _hoisted_8 = { class: "member-id" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "sisul-name-text" }
const _hoisted_11 = {
  key: 1,
  class: "sisul-edit-container"
}
const _hoisted_12 = { class: "text-left" }
const _hoisted_13 = { class: "login-date" }
const _hoisted_14 = { class: "login-time" }
const _hoisted_15 = {
  key: 1,
  class: "no-login"
}
const _hoisted_16 = { class: "no-data-message" }
const _hoisted_17 = { class: "ip-code" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "no-log-message" }

import { ref, computed, onMounted } from 'vue';
import axios from 'axios';
import WageTaxRes from '@/components/wage/tax/WageTaxRes.vue';

interface Member {
  m_idx: number;
  m_id: string;
  m_sisul_code: string;
  m_longterm_code: string;
  m_sisul_name: string;
  m_biz_gubun: string;
  m_biz_num: string;
  m_user_name: string;
  m_email: string;
  m_phone1: string;
  m_phone2: string;
  m_phone3: string;
  m_role: string;
  m_status: string;
  m_isuse: string;
  m_wdate: string;
  m_rdate: string;
}

interface LoginLog {
  log_idx: number;
  m_idx: number;
  m_id: string;
  m_user_name: string;
  m_sisul_name: string;
  log_type: 'LOGIN' | 'LOGOUT';
  log_ip: string;
  log_region: string;
  log_agent: string;
  log_time: string;
}

// 상태

export default /*@__PURE__*/_defineComponent({
  __name: 'AdminMembers',
  setup(__props) {

const loading = ref(false);
const members = ref<Member[]>([]);
const searchQuery = ref('');
const authFilter = ref<'all' | 'active' | 'inactive'>('active'); // 기본값: 인증된 기관만
const impersonatingId = ref<string | null>(null);
const updatingId = ref<string | null>(null);
const lastLoginMap = ref<Record<string, string>>({});
const loginLogsDialog = ref(false);
const loginLogs = ref<LoginLog[]>([]);
const selectedMember = ref<Member | null>(null);
const loadingLogs = ref(false);
const snackbar = ref({
  show: false,
  text: '',
  color: 'info'
});

// 대기중인 요청 관련
const pendingRequestsMap = ref<Record<string, number>>({});
const taxRequestModalVisible = ref(false);
const selectedMemberForRequest = ref<Member | null>(null);

// 기관명 편집 상태
const editingSisulId = ref<string | null>(null);
const editingSisulName = ref('');
const savingSisulName = ref(false);

// 테이블 헤더
const headers = [
  { title: '회원정보', key: 'm_user_name', sortable: true, width: '200px' },
  { title: '기관명', key: 'm_sisul_name', sortable: true },
  { title: '가입일', key: 'm_wdate', sortable: true, width: '120px' },
  { title: '최근 로그인', key: 'last_login', sortable: false, width: '120px', align: 'center' },
  { title: '요청', key: 'pending_requests', sortable: false, width: '100px', align: 'center' },
  { title: '기능', key: 'actions', sortable: false, width: '100px', align: 'center' },
  { title: '인증', key: 'm_isuse', sortable: true, width: '80px', align: 'center' }
];

// 로그 테이블 헤더
const logHeaders = [
  { title: '구분', key: 'log_type', sortable: false, width: '100px' },
  { title: '일시', key: 'log_time', sortable: true, width: '180px' },
  { title: 'IP', key: 'log_ip', sortable: false, width: '130px' },
  { title: '지역', key: 'log_region', sortable: false, width: '150px' },
  { title: '브라우저', key: 'log_agent', sortable: false }
];

// 필터링된 회원 목록
const filteredMembers = computed(() => {
  let result = members.value;
  
  // 인증 상태 필터
  if (authFilter.value === 'active') {
    result = result.filter(member => member.m_isuse === 'Y');
  } else if (authFilter.value === 'inactive') {
    result = result.filter(member => member.m_isuse !== 'Y');
  }
  
  // 검색어 필터
  if (searchQuery.value) {
    const query = searchQuery.value.toLowerCase();
    result = result.filter(member => 
      member.m_user_name?.toLowerCase().includes(query) ||
      member.m_id?.toLowerCase().includes(query) ||
      member.m_sisul_name?.toLowerCase().includes(query) ||
      `${member.m_phone1 || ''}${member.m_phone2 || ''}${member.m_phone3 || ''}`?.includes(query)
    );
  }
  
  return result;
});

// 회원 목록 로드
const loadMembers = async () => {
  loading.value = true;
  try {
    const response = await axios.get('/api/admin/members', {
      withCredentials: true
    });
    
    if (response.data.success) {
      members.value = response.data.members;
    } else {
      showSnackbar('회원 목록을 불러오는데 실패했습니다.', 'error');
    }
  } catch (error: any) {
    console.error('회원 목록 로드 오류:', error);
    if (error.response?.status === 403) {
      showSnackbar('관리자 권한이 필요합니다.', 'error');
    } else {
      showSnackbar('서버 오류가 발생했습니다.', 'error');
    }
  } finally {
    loading.value = false;
  }
};

// 전체 회원의 최근 로그인 정보 로드
const loadLastLoginInfo = async () => {
  try {
    const response = await axios.get('/api/admin/members/last-login', {
      withCredentials: true
    });
    
    if (response.data.success) {
      lastLoginMap.value = response.data.lastLoginMap;
    }
  } catch (error: any) {
    console.error('최근 로그인 정보 로드 오류:', error);
  }
};

// 대기중인 임금신고 요청 로드
const loadPendingRequests = async () => {
  try {
    const response = await axios.get('/api/wage-process/tax-request/pending-count', {
      withCredentials: true
    });
    
    if (response.data.success) {
      pendingRequestsMap.value = response.data.data || {};
    }
  } catch (error: any) {
    console.error('대기중인 요청 로드 오류:', error);
  }
};

// 임금신고 요청 모달 열기
const openTaxRequestModal = (member: Member) => {
  selectedMemberForRequest.value = member;
  taxRequestModalVisible.value = true;
};

// 요청 처리 완료 시
const handleRequestProcessed = () => {
  loadPendingRequests();
};

// 로그인 기록 모달 열기
const openLoginLogs = async (member: Member) => {
  selectedMember.value = member;
  loginLogsDialog.value = true;
  loadingLogs.value = true;
  
  try {
    const response = await axios.get(`/api/admin/members/${member.m_id}/logs`, {
      withCredentials: true
    });
    
    if (response.data.success) {
      loginLogs.value = response.data.logs;
    } else {
      showSnackbar('로그인 기록을 불러오는데 실패했습니다.', 'error');
    }
  } catch (error: any) {
    console.error('로그인 기록 로드 오류:', error);
    showSnackbar('서버 오류가 발생했습니다.', 'error');
  } finally {
    loadingLogs.value = false;
  }
};

// 기관명 편집 시작
const startEditSisulName = (member: Member) => {
  editingSisulId.value = member.m_id;
  editingSisulName.value = member.m_sisul_name || '';
};

// 기관명 편집 취소
const cancelEditSisulName = () => {
  editingSisulId.value = null;
  editingSisulName.value = '';
};

// 기관명 저장
const saveSisulName = async (member: Member) => {
  if (!editingSisulName.value.trim()) {
    showSnackbar('기관명을 입력해주세요.', 'warning');
    return;
  }
  
  savingSisulName.value = true;
  
  try {
    const response = await axios.put(`/api/admin/members/${member.m_id}/sisul-name`, {
      m_sisul_name: editingSisulName.value.trim()
    }, {
      withCredentials: true
    });
    
    if (response.data.success) {
      // 로컬 상태 업데이트
      const index = members.value.findIndex(m => m.m_id === member.m_id);
      if (index !== -1) {
        members.value[index].m_sisul_name = editingSisulName.value.trim();
      }
      showSnackbar('기관명이 변경되었습니다.', 'success');
      cancelEditSisulName();
    } else {
      showSnackbar(response.data.message || '기관명 변경에 실패했습니다.', 'error');
    }
  } catch (error: any) {
    console.error('기관명 변경 오류:', error);
    showSnackbar(error.response?.data?.message || '서버 오류가 발생했습니다.', 'error');
  } finally {
    savingSisulName.value = false;
  }
};

// 회원 m_isuse 상태 토글
const toggleMemberIsuse = async (member: Member, isActive: boolean) => {
  updatingId.value = member.m_id;
  const newValue = isActive ? 'Y' : 'N';
  
  try {
    const response = await axios.put(`/api/admin/members/${member.m_id}/isuse`, {
      m_isuse: newValue
    }, {
      withCredentials: true
    });
    
    if (response.data.success) {
      // 로컬 상태 업데이트
      const index = members.value.findIndex(m => m.m_id === member.m_id);
      if (index !== -1) {
        members.value[index].m_isuse = newValue;
      }
      showSnackbar(`${member.m_user_name}님의 인증 상태가 변경되었습니다.`, 'success');
    } else {
      showSnackbar(response.data.message || '상태 변경에 실패했습니다.', 'error');
    }
  } catch (error: any) {
    console.error('회원 상태 변경 오류:', error);
    showSnackbar(error.response?.data?.message || '서버 오류가 발생했습니다.', 'error');
  } finally {
    updatingId.value = null;
  }
};

// 대리 로그인 (회원 화면 보기)
const impersonateUser = async (member: Member) => {
  impersonatingId.value = member.m_id;
  
  try {
    // 1. 대리 로그인 토큰 요청
    const response = await axios.post('/api/admin/impersonate', {
      m_id: member.m_id
    }, {
      withCredentials: true
    });
    
    if (response.data.success) {
      const token = response.data.token;
      
      // 2. 새 창에서 토큰을 인증하여 로그인
      // URL에 토큰을 포함하여 새 창 열기
      const newWindow = window.open(
        `/pgm/login?impersonate=${encodeURIComponent(token)}`,
        '_blank',
        'width=1600,height=900'
      );
      
      if (!newWindow) {
        showSnackbar('팝업이 차단되었습니다. 팝업 차단을 해제해주세요.', 'warning');
      } else {
        showSnackbar(`${member.m_user_name}님의 화면을 새 창에서 열었습니다.`, 'success');
      }
    } else {
      showSnackbar(response.data.message || '대리 로그인에 실패했습니다.', 'error');
    }
  } catch (error: any) {
    console.error('대리 로그인 오류:', error);
    showSnackbar(error.response?.data?.message || '서버 오류가 발생했습니다.', 'error');
  } finally {
    impersonatingId.value = null;
  }
};

// 유틸리티 함수들
const getInitial = (name: string) => {
  return name ? name.charAt(0) : '?';
};

const formatBizNum = (num: string) => {
  if (!num) return '-';
  const cleaned = num.replace(/\D/g, '');
  if (cleaned.length === 10) {
    return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 5)}-${cleaned.slice(5)}`;
  }
  return num;
};

const formatPhone = (phone: string) => {
  if (!phone) return '-';
  const cleaned = phone.replace(/\D/g, '');
  if (cleaned.length === 11) {
    return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 7)}-${cleaned.slice(7)}`;
  }
  return phone;
};

const formatDate = (date: string) => {
  if (!date) return '-';
  return new Date(date).toLocaleDateString('ko-KR');
};

const formatTime = (date: string) => {
  if (!date) return '';
  return new Date(date).toLocaleTimeString('ko-KR', { hour: '2-digit', minute: '2-digit' });
};

const formatDateTime = (date: string) => {
  if (!date) return '-';
  const d = new Date(date);
  return `${d.toLocaleDateString('ko-KR')} ${d.toLocaleTimeString('ko-KR', { hour: '2-digit', minute: '2-digit', second: '2-digit' })}`;
};

const getLogTypeColor = (type: string) => {
  return type === 'LOGIN' ? 'success' : 'warning';
};

const getLogTypeText = (type: string) => {
  return type === 'LOGIN' ? '로그인' : '로그아웃';
};

const truncateAgent = (agent: string) => {
  if (!agent) return '-';
  // 브라우저 정보만 간단히 추출
  if (agent.includes('Chrome')) return 'Chrome';
  if (agent.includes('Firefox')) return 'Firefox';
  if (agent.includes('Safari')) return 'Safari';
  if (agent.includes('Edge')) return 'Edge';
  if (agent.includes('MSIE') || agent.includes('Trident')) return 'IE';
  return agent.length > 30 ? agent.substring(0, 30) + '...' : agent;
};

const getStatusColor = (status: string) => {
  switch (status) {
    case 'active': return 'success';
    case 'inactive': return 'grey';
    case 'pending': return 'warning';
    default: return 'grey';
  }
};

const getStatusText = (status: string) => {
  switch (status) {
    case 'active': return '활성';
    case 'inactive': return '비활성';
    case 'pending': return '대기';
    default: return status || '미설정';
  }
};

const showSnackbar = (text: string, color: string = 'info') => {
  snackbar.value = { show: true, text, color };
};

onMounted(() => {
  loadMembers();
  loadLastLoginInfo();
  loadPendingRequests();
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "header-content" }, [
        _createElementVNode("h1", { class: "page-title" }, "회원 관리"),
        _createElementVNode("p", { class: "page-subtitle" }, "등록된 회원 목록을 관리합니다")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_chip, {
          color: "primary",
          variant: "flat"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, {
              start: "",
              size: "small"
            }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createTextVNode("mdi-account-group", -1)
              ]))]),
              _: 1
            }),
            _createTextVNode(" 총 " + _toDisplayString(members.value.length) + "명 ", 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_v_card, {
      class: "search-card",
      elevation: "1"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_text, { class: "pa-4" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_text_field, {
                modelValue: searchQuery.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                "prepend-inner-icon": "mdi-magnify",
                label: "회원 검색",
                placeholder: "이름, 아이디, 기관명 검색",
                variant: "outlined",
                density: "compact",
                "hide-details": "",
                clearable: "",
                style: {"max-width":"300px"}
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn_toggle, {
                modelValue: authFilter.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((authFilter).value = $event)),
                mandatory: "",
                density: "compact",
                color: "primary",
                class: "auth-filter-toggle"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    value: "all",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        start: "",
                        size: "small"
                      }, {
                        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                          _createTextVNode("mdi-account-group", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[11] || (_cache[11] = _createTextVNode(" 전체 ", -1))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    value: "active",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        start: "",
                        size: "small"
                      }, {
                        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                          _createTextVNode("mdi-check-circle", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[13] || (_cache[13] = _createTextVNode(" 인증됨 ", -1))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    value: "inactive",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        start: "",
                        size: "small"
                      }, {
                        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                          _createTextVNode("mdi-close-circle", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[15] || (_cache[15] = _createTextVNode(" 미인증 ", -1))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_card, {
      class: "members-table-card",
      elevation: "1"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_data_table, {
          headers: headers,
          items: filteredMembers.value,
          loading: loading.value,
          "items-per-page": -1,
          class: "members-table",
          hover: ""
        }, {
          "item.m_user_name": _withCtx(({ item }) => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_v_avatar, {
                size: "36",
                color: "primary",
                class: "mr-3"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(getInitial(item.m_user_name)), 1)
                ]),
                _: 2
              }, 1024),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(item.m_user_name), 1),
                _createElementVNode("div", _hoisted_8, _toDisplayString(item.m_id), 1)
              ])
            ])
          ]),
          "item.m_sisul_name": _withCtx(({ item }) => [
            (editingSisulId.value !== item.m_id)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "sisul-info",
                  onClick: ($event: any) => (startEditSisulName(item))
                }, [
                  _createVNode(_component_v_icon, {
                    size: "small",
                    color: "grey",
                    class: "mr-1"
                  }, {
                    default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                      _createTextVNode("mdi-domain", -1)
                    ]))]),
                    _: 1
                  }),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(item.m_sisul_name || '-'), 1),
                  _createVNode(_component_v_icon, {
                    size: "x-small",
                    color: "grey",
                    class: "ml-1 edit-icon"
                  }, {
                    default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                      _createTextVNode("mdi-pencil", -1)
                    ]))]),
                    _: 1
                  })
                ], 8, _hoisted_9))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_v_text_field, {
                    modelValue: editingSisulName.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((editingSisulName).value = $event)),
                    variant: "outlined",
                    density: "compact",
                    "hide-details": "",
                    autofocus: "",
                    class: "sisul-edit-input",
                    onKeyup: [
                      _withKeys(($event: any) => (saveSisulName(item)), ["enter"]),
                      _withKeys(cancelEditSisulName, ["escape"])
                    ]
                  }, null, 8, ["modelValue", "onKeyup"]),
                  _createVNode(_component_v_btn, {
                    icon: "",
                    size: "small",
                    color: "success",
                    variant: "text",
                    onClick: ($event: any) => (saveSisulName(item)),
                    loading: savingSisulName.value
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { size: "small" }, {
                        default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                          _createTextVNode("mdi-check", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick", "loading"]),
                  _createVNode(_component_v_btn, {
                    icon: "",
                    size: "small",
                    color: "grey",
                    variant: "text",
                    onClick: cancelEditSisulName
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { size: "small" }, {
                        default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                          _createTextVNode("mdi-close", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
          ]),
          "item.m_isuse": _withCtx(({ item }) => [
            _createVNode(_component_v_switch, {
              "model-value": item.m_isuse === 'Y',
              "onUpdate:modelValue": (val) => toggleMemberIsuse(item, val),
              color: "success",
              "hide-details": "",
              density: "compact",
              loading: updatingId.value === item.m_id,
              disabled: updatingId.value === item.m_id
            }, null, 8, ["model-value", "onUpdate:modelValue", "loading", "disabled"])
          ]),
          "item.m_wdate": _withCtx(({ item }) => [
            _createTextVNode(_toDisplayString(formatDate(item.m_wdate)), 1)
          ]),
          "item.last_login": _withCtx(({ item }) => [
            (lastLoginMap.value[item.m_id])
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  variant: "text",
                  size: "small",
                  color: "primary",
                  onClick: ($event: any) => (openLoginLogs(item)),
                  class: "login-log-btn"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, _toDisplayString(formatDate(lastLoginMap.value[item.m_id])), 1),
                      _createElementVNode("div", _hoisted_14, _toDisplayString(formatTime(lastLoginMap.value[item.m_id])), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_15, "-"))
          ]),
          "item.pending_requests": _withCtx(({ item }) => [
            _createVNode(_component_v_btn, {
              variant: pendingRequestsMap.value[item.m_sisul_code] ? 'flat' : 'text',
              size: "small",
              color: pendingRequestsMap.value[item.m_sisul_code] ? 'warning' : 'grey',
              onClick: ($event: any) => (openTaxRequestModal(item)),
              class: _normalizeClass(["request-history-btn", { 'has-pending': pendingRequestsMap.value[item.m_sisul_code] }])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  size: "16",
                  class: _normalizeClass({ 'mr-1': pendingRequestsMap.value[item.m_sisul_code] })
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(pendingRequestsMap.value[item.m_sisul_code] ? 'mdi-file-document-alert' : 'mdi-file-document-outline'), 1)
                  ]),
                  _: 2
                }, 1032, ["class"]),
                (pendingRequestsMap.value[item.m_sisul_code])
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(pendingRequestsMap.value[item.m_sisul_code]) + "건 ", 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["variant", "color", "onClick", "class"])
          ]),
          "item.actions": _withCtx(({ item }) => [
            _createVNode(_component_v_btn, {
              color: "primary",
              variant: "tonal",
              size: "small",
              onClick: ($event: any) => (impersonateUser(item)),
              loading: impersonatingId.value === item.m_id
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  start: "",
                  size: "small"
                }, {
                  default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                    _createTextVNode("mdi-eye", -1)
                  ]))]),
                  _: 1
                }),
                _cache[21] || (_cache[21] = _createTextVNode(" 센터접속 ", -1))
              ]),
              _: 1
            }, 8, ["onClick", "loading"])
          ]),
          loading: _withCtx(() => [
            _createVNode(_component_v_skeleton_loader, { type: "table-row@10" })
          ]),
          "no-data": _withCtx(() => [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_v_icon, {
                size: "64",
                color: "grey-lighten-1"
              }, {
                default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                  _createTextVNode("mdi-account-off", -1)
                ]))]),
                _: 1
              }),
              _cache[23] || (_cache[23] = _createElementVNode("p", null, "등록된 회원이 없습니다", -1))
            ])
          ]),
          _: 1
        }, 8, ["items", "loading"])
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: loginLogsDialog.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((loginLogsDialog).value = $event)),
      "max-width": "900px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "log-dialog-title" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { class: "mr-2" }, {
                  default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                    _createTextVNode("mdi-history", -1)
                  ]))]),
                  _: 1
                }),
                _createTextVNode(" " + _toDisplayString(selectedMember.value?.m_user_name) + "님의 로그인 기록 ", 1),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  icon: "",
                  variant: "text",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (loginLogsDialog.value = false))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                        _createTextVNode("mdi-close", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_text, { class: "pa-0" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_data_table, {
                  headers: logHeaders,
                  items: loginLogs.value,
                  loading: loadingLogs.value,
                  "items-per-page": 10,
                  class: "log-table",
                  density: "compact"
                }, {
                  "item.log_type": _withCtx(({ item }) => [
                    _createVNode(_component_v_chip, {
                      color: getLogTypeColor(item.log_type),
                      size: "small",
                      variant: "flat"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          start: "",
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.log_type === 'LOGIN' ? 'mdi-login' : 'mdi-logout'), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createTextVNode(" " + _toDisplayString(getLogTypeText(item.log_type)), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"])
                  ]),
                  "item.log_time": _withCtx(({ item }) => [
                    _createTextVNode(_toDisplayString(formatDateTime(item.log_time)), 1)
                  ]),
                  "item.log_ip": _withCtx(({ item }) => [
                    _createElementVNode("code", _hoisted_17, _toDisplayString(item.log_ip || '-'), 1)
                  ]),
                  "item.log_region": _withCtx(({ item }) => [
                    (item.log_region)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                          _createVNode(_component_v_icon, {
                            size: "small",
                            class: "mr-1"
                          }, {
                            default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                              _createTextVNode("mdi-map-marker", -1)
                            ]))]),
                            _: 1
                          }),
                          _createTextVNode(" " + _toDisplayString(item.log_region), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_19, "-"))
                  ]),
                  "item.log_agent": _withCtx(({ item }) => [
                    _createVNode(_component_v_tooltip, {
                      text: item.log_agent,
                      location: "top",
                      "max-width": "400"
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createElementVNode("span", _mergeProps(props, { class: "agent-text" }), _toDisplayString(truncateAgent(item.log_agent)), 17)
                      ]),
                      _: 2
                    }, 1032, ["text"])
                  ]),
                  loading: _withCtx(() => [
                    _createVNode(_component_v_skeleton_loader, { type: "table-row@5" })
                  ]),
                  "no-data": _withCtx(() => [
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_v_icon, {
                        size: "48",
                        color: "grey-lighten-1"
                      }, {
                        default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                          _createTextVNode("mdi-history", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[28] || (_cache[28] = _createElementVNode("p", null, "로그인 기록이 없습니다", -1))
                    ])
                  ]),
                  _: 1
                }, 8, ["items", "loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(WageTaxRes, {
      modelValue: taxRequestModalVisible.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((taxRequestModalVisible).value = $event)),
      "sisul-code": selectedMemberForRequest.value?.m_sisul_code || '',
      "sisul-name": selectedMemberForRequest.value?.m_sisul_name || '',
      onProcessed: handleRequestProcessed
    }, null, 8, ["modelValue", "sisul-code", "sisul-name"]),
    _createVNode(_component_v_snackbar, {
      modelValue: snackbar.value.show,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((snackbar.value.show) = $event)),
      color: snackbar.value.color,
      timeout: 3000,
      location: "top"
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_btn, {
          variant: "text",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (snackbar.value.show = false))
        }, {
          default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
            _createTextVNode("닫기", -1)
          ]))]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(snackbar.value.text) + " ", 1)
      ]),
      _: 1
    }, 8, ["modelValue", "color"])
  ]))
}
}

})